import { IUserJWT } from '@Types/user_type'
import axios from 'axios'

interface ClearCacheApiParams {
    url: string
    user: any
}

export const clearCacheApi = async ({ url, user }: ClearCacheApiParams) => {
    const postData = {
        url: url.replace(/^(https?:\/\/)(?!www\.)/, '$1www.'),
        lineNoti: false,
        user: user.nick_name || `${user.first_name || ''} ${user.last_name || ''}`,
    };

    try {
        const response: any = await axios.post(`${process.env.REACT_APP_MIRROR_API}/api/clearcache`, postData)

        if(response){
            return response?.data.data.status
        }
    } catch (error) {
        console.error('Error clearing cache:', error);
    }
}